var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotRecommend",on:{"click":function($event){return _vm.$emit('closeHotPopup')}}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("热门课程")]),_c('div',{staticClass:"contentList"},[_c('RecommendCourse')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }